// extracted by mini-css-extract-plugin
export default {"container":"WarehouseProfile_container__pdOYr","infoGrid":"WarehouseProfile_infoGrid__1b8fP","version":"WarehouseProfile_version__7M9H4"};